export const announce = {
    "announcement": {
        "announcement01": "Announcement Date",
        "announcement02": "Announcement Title",
        "announcement03": "Notice",
        "announcement04": "Annex",
        "announcement05": "Announcement-Create",
        "announcement06": "Announcement-Update"
    }
}
